/**
 * HNB-575 — Klaviyo embed forms (e.g. Join the Potato Club):
 * country field is a Downshift combobox with a clipped sr-only label.
 * Ensure an accessible name and quiet empty collapsed listboxes for auditors.
 */
(function () {
  if (window._mfrA11yKlaviyoForm) return;
  window._mfrA11yKlaviyoForm = true;

  function labelTextFor(control) {
    if (!control) return '';
    var byId = control.id
      ? document.querySelector('label[for="' + CSS.escape(control.id) + '"]')
      : null;
    if (byId && (byId.textContent || '').trim()) return byId.textContent.trim();
    var labelledby = control.getAttribute('aria-labelledby');
    if (labelledby) {
      var parts = labelledby.split(/\s+/).map(function (id) {
        var el = document.getElementById(id);
        return el ? (el.textContent || '').trim() : '';
      });
      var joined = parts.filter(Boolean).join(' ');
      if (joined) return joined;
    }
    return (control.getAttribute('placeholder') || '').trim();
  }

  function fixCombobox(input) {
    if (!(input instanceof Element)) return;
    var name = labelTextFor(input);
    var hasForLabel = !!(
      input.id && document.querySelector('label[for="' + CSS.escape(input.id) + '"]')
    );
    // Prefer a real <label>; aria-label + label = WAVE "Multiple form labels".
    if (name && !hasForLabel && !input.getAttribute('aria-label')) {
      input.setAttribute('aria-label', name);
    }

    var menuId = input.getAttribute('aria-controls') || input.getAttribute('aria-owns');
    var menu = menuId ? document.getElementById(menuId) : null;
    if (!menu) return;

    var expanded = input.getAttribute('aria-expanded') === 'true';
    var hasOptions = !!menu.querySelector('[role="option"], [role="group"]');
    if (!expanded && !hasOptions) {
      menu.setAttribute('aria-hidden', 'true');
    } else {
      menu.removeAttribute('aria-hidden');
    }
  }

  function fixRoot(root) {
    (root || document)
      .querySelectorAll(
        '.klaviyo-form [role="combobox"], [class*="klaviyo-form"] [role="combobox"]'
      )
      .forEach(fixCombobox);

    (root || document)
      .querySelectorAll(
        '.klaviyo-form select, [class*="klaviyo-form"] select'
      )
      .forEach(function (select) {
        var name = labelTextFor(select);
        if (!name) return;
        if (!select.id) {
          select.id = 'klaviyo-a11y-select-' + Math.random().toString(36).slice(2, 8);
        }
        var label =
          (select.id && document.querySelector('label[for="' + CSS.escape(select.id) + '"]')) ||
          null;
        if (label && !label.getAttribute('for')) label.setAttribute('for', select.id);
        if (!label && !select.getAttribute('aria-label')) {
          select.setAttribute('aria-label', name);
        }
      });

    // Consent checkboxes often ship with both <label for> and aria-label.
    // Inputs use classes like `klaviyo-sr-only`, not always a `.klaviyo-form` ancestor.
    (root || document)
      .querySelectorAll(
        '.klaviyo-form input[aria-label], [class*="klaviyo-form"] input[aria-label], input[class*="klaviyo"][aria-label]'
      )
      .forEach(function (input) {
        if (
          input.id &&
          document.querySelector('label[for="' + CSS.escape(input.id) + '"]')
        ) {
          input.removeAttribute('aria-label');
        }
      });
  }

  function observe() {
    fixRoot(document);

    document.addEventListener(
      'click',
      function () {
        window.setTimeout(function () {
          fixRoot(document);
        }, 0);
      },
      true
    );

    document.addEventListener(
      'keydown',
      function () {
        window.setTimeout(function () {
          fixRoot(document);
        }, 0);
      },
      true
    );

    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function () {
      fixRoot(document);
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-expanded', 'class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
